import React from 'react';
import { BaasicDragAndDropTemplate } from 'themes/components';
import PropTypes from 'prop-types';

function BaasicDragAndDrop(props) {
	return <BaasicDragAndDropTemplate {...props} />;
}

BaasicDragAndDrop.propTypes = {
	dropBox: PropTypes.object,
	dragAndDropField: PropTypes.string,
	onDropCallback: PropTypes.func,
	className: PropTypes.string,
	ItemComponent: PropTypes.elementType,
};

export default BaasicDragAndDrop;
